<template>
    <div>
        <div
            style="
                font-size: 34px;
                font-weight: bold;
                margin-bottom: 22px;
                color: red;
            "
        >
            <p>
                <span>Sử dụng bằng cách copy thẻ bên dưới</span>
            </p>
        </div>

        <el-row :gutter="20">
            <el-col>
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
                    <el-form-item>
                        <template #label>
                            <div class="flex-center">
                                <p>Label name</p>
                                <el-tooltip
                                    :visible-arrow="false"
                                    class="color-primary-600"
                                    effect="dark"
                                    content="Bottom Left prompts info"
                                    placement="right-end"
                                >
                                    <span class="icon-error"></span>
                                </el-tooltip>
                            </div>
                        </template>

                        <el-input placeholder="Please input" v-model="input">
                            <span slot="suffix" class="el-input__icon">
                                <span class="body-small-regular neutral-600"
                                    >Subtext</span
                                >
                            </span>
                        </el-input>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    data() {
        return {
            textFilled: "Text đây nè",
            textarea1: "",
            input: "",

            ruleForm: {
                name: "",
                password: "",
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: "Error message",
                        trigger: "blur",
                    },
                ],
                password: [
                    {
                        required: true,
                        message: "Error message",
                        trigger: "blur",
                    },
                ],
            },
            ui: {
                showPassword: false,
            },
        };
    },
};
</script>

<style lang="scss" scoped>
.el-row {
    margin: 24px 12px;
    display: flex;
    align-items: center;
}
</style>
<style lang="scss">
.el-tooltip {
    z-index: 99;
}
.el-tooltip__popper.is-dark {
    border-radius: 6px;
    background: var(--neutral-800);
}
</style>
